/* Generated by TinySVG. Do not edit directly. */
import type { TinyIconProps } from '../types.ts'

export function BoxesIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth,
  title,
  ...svgProps
}: TinyIconProps) {
  const resolvedStrokeWidth = strokeWidth ?? 1.75
  const scaledStrokeWidth = (percent: number) => {
    const numericStrokeWidth = typeof resolvedStrokeWidth === 'number' ? resolvedStrokeWidth : Number(resolvedStrokeWidth)
    return Number.isFinite(numericStrokeWidth) ? numericStrokeWidth * percent / 100 : resolvedStrokeWidth
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeWidth={resolvedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      data-icon="boxes"
      data-variant="outline"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
          <path d="M8 5.5C8 4.395 8.895 3.5 10 3.5L14 3.5C15.105 3.5 16 4.395 16 5.5L16 9.5C16 10.605 15.105 11.5 14 11.5L10 11.5C8.895 11.5 8 10.605 8 9.5L8 5.5Z" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M12.5 14.5C12.5 13.395 13.395 12.5 14.5 12.5L18.5 12.5C19.605 12.5 20.5 13.395 20.5 14.5L20.5 18.5C20.5 19.605 19.605 20.5 18.5 20.5L14.5 20.5C13.395 20.5 12.5 19.605 12.5 18.5L12.5 14.5Z" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M3.5 14.5C3.5 13.395 4.395 12.5 5.5 12.5L9.5 12.5C10.605 12.5 11.5 13.395 11.5 14.5L11.5 18.5C11.5 19.605 10.605 20.5 9.5 20.5L5.5 20.5C4.395 20.5 3.5 19.605 3.5 18.5L3.5 14.5Z" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M12 3.5L12 6" data-tinysvg-shape="line" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M16.5 13L16.5 15" data-tinysvg-shape="line" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M7.5 13L7.5 15" data-tinysvg-shape="line" stroke={color} fill="none" data-stroke-tone="primary" />
    </svg>
  )
}
